import React, { useContext, useEffect, useState } from 'react';

import { PagesContext } from '../store/PagesContext';

import Columns from '../components/Columns';
import FMVPopups from '../components/popups/FMVPopups';

const NsoK = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const openPopup = () => setIsPopupOpen(true);

  const [, setLastPage] = useContext(PagesContext);

  useEffect(() => setLastPage('nsoJ'), []);

  const sideContent = 'If you hold onto your stocks for less than 1 year, you will not pay ordinary income taxes.';

  return (
    <>
      <Columns sideContent={sideContent} theme='red'>
        <p>
          Instead, you will be subject to paying short term capital gains tax rates on the increase in{' '}
          <span className='color-red c-pointer' onClick={openPopup}>
            FMV (fair market value)
          </span>{' '}
          after exercise.
        </p>
      </Columns>

      <FMVPopups isFMVPopupOpen={isPopupOpen} setIsFMVPopupOpen={setIsPopupOpen} />
    </>
  );
};

export default NsoK;
